// Utility to suppress ResizeObserver loop limit exceeded error
export const suppressResizeObserverLoopError = () => {
  const resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/;
  const originalConsoleError = window.console.error;

  window.console.error = (...args: any) => {
    if (
      typeof args[0] === 'string' &&
      resizeObserverLoopErrRe.test(args[0])
    ) {
      // Ignore ResizeObserver loop completed/limit exceeded error
      return;
    }
    originalConsoleError.apply(window.console, args);
  };
};